import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { isDefined } from '@fi-shared/utils';

@Component({
    selector: 'fi-date-time-picker-dialog-time-input',
    template: `
        <div class="time-input-wrapper">
            <button mat-icon-button [disabled]="isIncreaseButtonDisabled()" (click)="increaseValue()">
                <mat-icon class="fa-sharp fa-regular fa-chevron-up"></mat-icon>
            </button>

            <mat-form-field appearance="fill" class="no-padding-form-field">
                <input
                    type="number"
                    name="timeValue"
                    matInput
                    [max]="maxValue"
                    [min]="minValue"
                    [required]="true"
                    class="input-number no-arrows"
                    [(ngModel)]="ngModel"
                    (ngModelChange)="doPropagateChanges()"
                />
            </mat-form-field>

            <button mat-icon-button [disabled]="isDecreaseButtonDisabled()" (click)="decreaseValue()">
                <mat-icon class="fa-sharp fa-regular fa-chevron-down"></mat-icon>
            </button>
        </div>
    `,
    styleUrls: ['./fi-date-time-picker-dialog-time-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-date-time-picker-dialog-time-input' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FiDateTimePickerDialogTimeInputComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: FiDateTimePickerDialogTimeInputComponent,
        },
    ],
    standalone: false,
})
export class FiDateTimePickerDialogTimeInputComponent extends ControlValueAccessorValidatorBase<number> {
    @Input() maxValue: number;
    @Input() minValue: number = 0;

    isIncreaseButtonDisabled(): boolean {
        return this.ngModel >= this.maxValue;
    }

    isDecreaseButtonDisabled(): boolean {
        return this.ngModel <= this.minValue;
    }

    increaseValue() {
        this.ngModel++;
        this.doPropagateChanges();
    }

    decreaseValue() {
        this.ngModel--;
        this.doPropagateChanges();
    }

    doValidate(): ValidationErrors {
        return {
            required: !isDefined(this.ngModel),
            'less-than-min': this.ngModel < this.minValue,
            'more-than-max': this.ngModel > this.maxValue,
        };
    }
}
